<template>
    <div>
        <div v-if="expiredLink === true">
            <div class="p-8 -mb-4">
                <h1 class="mb-8 font-bold text-3xl">Password reset link not valid</h1>
                <p>This password reset link has either already been used or has expired</p>
                <p class="mt-4"><router-link :to="{ name: 'Forgot Password' }">Click here to return request a new password reset link</router-link></p>
            </div>
        </div>
        <div v-if="pageLoaded && !successMessage" class="w-full md:w-4/5 m-auto py-6 px-12">
            <div class="bg-white bg-gray-100 border px-2 py-2 mt-1 pb-6">
                <div class="px-4 bg-gray-100">
                    <div>
                        <div class="p-8 -mb-8">
                            <h1 class="mb-8 font-bold text-3xl">Reset Password</h1>
                        </div>
                        <div id="personal_details_content"
                             class="bg-white border border-t-0 border-gray-300 overflow-hidden"
                        >
                            <div>
                                <h2 class="mb-3 mt-4 pl-8 font-bold text-2xl">Reset Password Form</h2>
                                <p class="text-left pl-8 pr-8">Please provide a new password for your account</p>
                                <form id="smmr-form" @submit.prevent="update">
                                    <div class="p-8 pb-2 flex flex-wrap" @change="dirtyForm()">
                                        <text-input v-model="form.password" type="password" class="pr-6" :width="'full'" label="New Password"
                                                    @update:modelValue="value = $event"
                                        />
                                        <text-input v-model="form.password_confirmation" type="password" :width="'full'" class="pr-6" label="Confirm New Password"
                                                    @update:modelValue="value = $event"
                                        />
                                    </div>
                                    <div v-if="serverErrors" class="m-8 server-error">
                                        <div v-for="(value, key) in serverErrors" :key="key">
                                            {{ value[0] }}
                                        </div>
                                    </div>
                                    <div class="lg:flex justify-end w-full pb-2 -mt-8">
                                        <div class="relative w-auto lg:w-1/3 mx-8">
                                            <application-component-save-button :disabled="formDirty"
                                                                               class="w-full flex btn-green ml-auto mt-8 md:inline-block text-center"
                                                                               type="submit"
                                            >
                                                Update my password
                                                <div v-if="loading" class="lds-ring-container absolute top-10">
                                                    <div class="lds-ring">
                                                        <div />
                                                        <div />
                                                        <div />
                                                        <div />
                                                    </div>
                                                </div>
                                            </application-component-save-button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="successMessage" class="w-full flex flex-col items-center">
            <div class="w-1/2 success-message m-8 w-auto">
                <p>{{ successMessage }}</p>
            </div>

            <p><router-link :to="{ name: 'Login' }">Click here to log in</router-link></p>
        </div>
    </div>
</template>

<script>
import TextInput from '../../shared/TextInput'
import ApplicationComponentSaveButton from '@/shared/ApplicationComponentSaveButton'

export default {
    name: 'ResetPassword',
    components: {
        TextInput,
        ApplicationComponentSaveButton,
    },
    metaInfo: {title: 'Forgot Password'},

    data() {
        return {
            form: ({
                password: null,
                password_confirmation: null,
            }),

            formDirty: false,
            loading: false,
            successMessage: '',
            serverErrors: '',
            pageLoaded: false,
            expiredLink: false,
        }
    },
    created() {
        this.loadPage()
    },
    methods: {
        update() {
            this.loading = true
                this.$store.dispatch('updatePasswordWithTokens', {
                    reference: this.$route.params.id,
                    token: this.$route.params.token,
                    forgotPasswordData: this.form,
                })
                    .then((response) => {
                        this.loading = false
                            this.serverErrors = ''
                            this.successMessage = response.data
                    })
                    .catch(error => {
                        this.loading = false
                        this.serverErrors = Object.values(error.response.data.errors)
                        this.successMessage = ''

                    })
            this.formDirty = false
        },
        dirtyForm() {
            this.formDirty = true
            this.successMessage = ''
        },
        loadPage() {
            this.$store.dispatch('checkResetPasswordDetails', {
                reference: this.$route.params.id,
                token: this.$route.params.token,
            }).then(() => {
                this.pageLoaded = true
                this.template = 'page'
            })
                .catch(error => {
                    if (error.response.status === 400) {
                        this.expiredLink = true
                    }
                })
        },
    },
}
</script>
